<h2 *ngIf="!data.resource" matDialogTitle>Add new resource</h2>
<h2 *ngIf="data.resource" matDialogTitle>Edit resource</h2>

<mat-dialog-content>

  <app-message-panel kind="ERROR" *ngIf="errors">{{errors}}</app-message-panel>

  <form [formGroup]="fg" novalidate>
    <div class="row">

      <div class="col-sm-6 col-xs-12">
        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" />
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
        </div>
        <ng-container *ngIf="fg.value.attachment.itemType !== 'CARD'">
          <div class="form-group">
            <mat-form-field appearance="fill" class="small">
              <mat-label>Add to page...</mat-label>
              <mat-select formControlName="addToPage">
                <mat-option *ngFor="let page of availablePages" [value]="page">{{page}}</mat-option>
              </mat-select>
            </mat-form-field>
            <br />
            <button mat-button (click)="addPageToList()">Add page to list</button>
          </div>
          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Pages (separated by comma)</mat-label>
              <textarea matInput formControlName="pages"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
        <div *ngIf="fg.value.attachment.itemType !== 'CARD'" class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Categories (separated by comma)</mat-label>
            <textarea matInput formControlName="categories"></textarea>
          </mat-form-field>
        </div>
        <div *ngIf="fg.value.attachment.itemType !== 'CARD'" class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Keywords (separated by comma)</mat-label>
            <textarea matInput formControlName="keywords"></textarea>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>View priority</mat-label>
            <input matInput formControlName="order" />
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-checkbox class="md-primary" formControlName="visible">Visible?</mat-checkbox>
        </div>
      </div>

      <div class="col-sm-6 col-xs-12" formGroupName="attachment">
        <div class="form-group">
          <app-file-upload [imageMode]="true" placeholder="Choose resource thumbnail image..."
            [initialUrl]="data.resource ? data.resource.imageUrl : null" (onData)="handleThumbnailData($event)">
          </app-file-upload>
        </div>
        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Type</mat-label>
            <mat-select formControlName="itemType">
              <mat-option value="DOWNLOAD">Downloadable file</mat-option>
              <mat-option value="VIDEO">Video</mat-option>
              <mat-option value="CARD">Card UI element</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group" *ngIf="fg.value.attachment.itemType === 'VIDEO'">
          <mat-form-field appearance="fill">
            <mat-label>Video URL</mat-label>
            <input matInput formControlName="url" />
          </mat-form-field>
        </div>
        <div class="form-group" *ngIf="fg.value.attachment.itemType === 'DOWNLOAD'">
          <app-file-upload [imageMode]="false" placeholder="Choose file attachment..."
            [initialUrl]="fg.value.attachment.url" (onData)="handleAttachmentFileData($event)">
          </app-file-upload>
        </div>
        <div class="form-group" *ngIf="fg.value.attachment.itemType === 'DOWNLOAD'">
          <mat-form-field appearance="fill">
            <mat-label>Name of file when downloaded</mat-label>
            <input matInput formControlName="downloadName" />
          </mat-form-field>
        </div>

        <!-- We can repurpose these unused columns for CARD types -->
        <ng-container *ngIf="fg.value.attachment.itemType === 'CARD'">
          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Find out more link</mat-label>
              <input matInput formControlName="downloadName" />
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Sign in link</mat-label>
              <input matInput formControlName="url" />
            </mat-form-field>
          </div>
        </ng-container>
      </div>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [matDialogClose]="false">Cancel</button>
  <button mat-button (click)="onSave()">Save</button>
</mat-dialog-actions>